import _ from "lodash";
import Plyr from "plyr";
import Hls from "hls.js";
import { call, sync } from "vuex-pathify";

let playerShowcase = {
  props: {
    showcase_id: String,
  },
  data() {
    return {
      ctnShowcase: {},
      timePlay: null,
      shops: [],
      duration: 0,
      plyr: null,
      hls: null,
      video: null,
      heightText: 30,
      showIconShopping: true,
      showInfoProd: false,
      showLabelProd: false,
      showRecBoxProd: false,
      showPrPanel: true,
      slotPanel: false,
      expireLabel: 5, // thời gian hết hạn của label product (s)
      maxRangeSplitScene: 5, // khoảng cách lớn nhất giữa 2 scene để 2 scene thuộc 2 phân đoạn lớn tách rời (s)
      buffTimeSeek: 2, // Khoảng thời gian buffer để đến với showcase khi người dùng next hoặc pre main showcase
      productMarkShowed: [],
      showcaseMainScene: [],
      waiting: false,
    };
  },
  async created() {
    console.log("Start created mixin");
    await this.getDetailShowcase(this.showcase_id);
    await this.prepareForNewCnt({
      ...this.showcaseCr,
    });
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
    showcaseCr: sync("showcase/currentShowcase"),
  },
  methods: {
    getDetailShowcase: call("showcase/getDetailShowcase"),
    async _fetchMessages() {},
    _detectFixedPosition(shop) {
      /*
       * xác định vị trí của trọng tâm sản phân đang nằm ở góc phần tư nào trên player
       * */
      const center = {
        x: shop.x + shop.width / 2,
        y: shop.y + shop.height / 2,
      };
      if (center.y <= 0.5 && center.x <= 0.5) {
        return "4"; // top, left => return bottom- right
      }

      if (center.y <= 0.5 && center.x >= 0.5) {
        return "3"; // top, right => return bottom- left
      }

      if (center.y >= 0.5 && center.x <= 0.5) {
        return "2"; // bottom, left => return top- right
      }
      if (center.y >= 0.5 && center.x >= 0.5) {
        return "1"; // bottom, right => return top- left
      }
    },
    _getMetaDataInTime(data, currentTimeVideo) {
      /*
         So sánh và get meta data tại thời điểm  hiện tại video display
      */
      return (
        _.filter(data, (o) => {
          return (
            o["itv"][0] <= currentTimeVideo && o["itv"][1] >= currentTimeVideo
          );
        }) || []
      );
    },
    getCurrentMetaWithPos() {
      /*
             * Get meta data tại thời điểm video hiện tại và xác định
                vị trí góc phần tư trọng tâm của box sản phẩm
             * */
      let res = [];
      if (this.timePlay) {
        const messages = this._getMetaDataInTime(
          this.showcaseCr.data,
          this.timePlay
        );
        for (let message of messages) {
          for (const box of message.pred_boxes) {
            res.push({
              ...box,
              pos: this._detectFixedPosition(box),
            });
          }
        }
      }
      return res;
    },
    onBuyNow(url) {
      window.open(url, "_blank");
    },
    calculatePosText(box) {
      /*
             * Phát sinh vị trí hiển thị label sản phẩm (vị trí này
               sẽ được giữ xuyên suốt cho đến khi box biến mất)
             * */
      const posBoxCenter = {
        x: box.x + box.width / 2,
        y: box.y + box.height / 2,
      };
      switch (box.pos) {
        case "4":
          return {
            x: posBoxCenter.x + 0.15 * this.video.clientWidth,
            y: posBoxCenter.y + 0.25 * this.video.clientHeight,
            height: this.heightText,
          };
        case "3":
          return {
            x: posBoxCenter.x - 0.15 * this.video.clientWidth,
            y: posBoxCenter.y + 0.25 * this.video.clientHeight,
            height: this.heightText,
          };
        case "2":
          return {
            x: posBoxCenter.x + 0.15 * this.video.clientWidth,
            y: posBoxCenter.y - 0.25 * this.video.clientHeight,
            height: this.heightText,
          };
        case "1":
          return {
            x: posBoxCenter.x - 0.15 * this.video.clientWidth,
            y: posBoxCenter.y - 0.25 * this.video.clientHeight,
            height: this.heightText,
          };
        default:
          return null;
      }
    },
    callRotate(A, C) {
      /*
            "a,b ,c là tam giác cân, a là điểm đầu nối đầu tiên của mục thông tin hiển thị," +
              "b là điểm cuối của mục thông tin hiển thị, c là nút click mua hàng," +
              " => hàm cần tính góc xoay từ cạnh ab để được cạnh ac"
            * */
      //    tính cạnh bc , ab=ac
      const b = Math.sqrt((A.x - C.x) ** 2 + (A.y - C.y) ** 2);
      const B = { x: A.x + b, y: A.y };
      const c = b;
      const a = Math.sqrt((B.x - C.x) ** 2 + (B.y - C.y) ** 2);
      const cosA = (b ** 2 + c ** 2 - a ** 2) / (2 * b * c);
      let aDeg = Math.abs(Math.acos(cosA) * 57.2957795);
      //  Xem A là gốc xoay nếu c nằm dưới a thì quay theo chiều kim đồng hộ, c nằm trên thì ngược lại
      if (C.y > A.y) {
        return aDeg;
      } else {
        return -aDeg;
      }
    },
    calLineAnimate(posTex, box) {
      /*
       * Tính toán thông tin đường kẻ nối trọng tâm sản phẩm và lable thông tin
       * Bao gồm vị trí mốc line, chiều dài line, gốc xoay line
       * */
      const posBoxCenter = {
        x: box.x + box.width / 2,
        y: box.y + box.height / 2,
      };
      let distance =
        Math.sqrt(
          (posBoxCenter.x - posTex.x) ** 2 + (posBoxCenter.y - posTex.y) ** 2
        ) - 18;
      let rotate = this.callRotate(posTex, posBoxCenter);
      let x = posTex.x;
      let y = posTex.y;
      return { width: distance, rotate: rotate, x: x, y: y };
    },
    _innitVideoPlayer() {
      let video = document.querySelector("#player-video");
      const domPlayerContainer = document.querySelector(".player-container");
      const domAdsContainer = document.querySelector(".ads-container");
      domPlayerContainer.removeChild(domAdsContainer);
      const updateAdsPosition = () => {
        console.log("Update updateAdsPosition mixin");
        const messages = this.getCurrentMetaWithPos();
        let index = 0;
        for (let oldShop of this.shops) {
          let updateShop = _.find(messages, { id: oldShop.id });
          if (updateShop) {
            const clientW = this.video.clientWidth;
            const clientH = this.video.clientHeight;
            oldShop.x = updateShop.x * clientW;
            oldShop.y = updateShop.y * clientH;
            oldShop.width = updateShop.width * clientW;
            oldShop.height = updateShop.height * clientH;
            oldShop.lineData = this.calLineAnimate(oldShop.textData, oldShop);
            _.remove(messages, { id: oldShop.id });
          } else {
            this.shops.splice(index, 1);
          }
          index += 1;
        }
        for (const message of messages) {
          const infoShop =
            _.find(this.showcaseCr.metadata || [], {
              id: message.id,
            }) || {};
          const clientW = this.video.clientWidth;
          const clientH = this.video.clientHeight;
          let x = message.x * clientW;
          let y = message.y * clientH;
          let width = message.width * clientW;
          let height = message.height * clientH;
          let pos = message.pos;
          const textData = this.calculatePosText({
            x: x,
            y: y,
            width: width,
            height: height,
            pos: pos,
          });
          let timeStart = Math.round(new Date().getTime() / 1000);
          if (this.productMarkShowed.includes(infoShop.id)) {
            timeStart = 0;
          }
          const newShop = {
            x: x,
            y: y,
            width: width,
            height: height,
            pos: pos,
            textData: textData,
            lineData: this.calLineAnimate(textData, { x: x, y: y, pos: pos }),
            ...infoShop,
            timeStart: timeStart,
          };
          this.shops.push(newShop);
        }
      };
      this.plyr = new Plyr(video, {
        captions: { active: true, update: true, language: "en" },
        title: this.title,
        clickToPlay: true,
        autoplay: false,
      });
      this.plyr.on("controlsshown", () => {
        let controlScene = document.getElementById("control-scene");
        if (controlScene) {
          controlScene.style.opacity = 0.8;
        }
        let drawerMisson = document.getElementsByClassName("drawer-mission")[0];
        if (drawerMisson) {
          drawerMisson.style.display = "flex";
        }
        let missionBoard = document.getElementsByClassName("mission-board")[0];
        if (missionBoard) {
          missionBoard.style.display = "flex";
        }
      });
      this.plyr.on("controlshidden", () => {
        let controlScene = document.getElementById("control-scene");
        if (controlScene) {
          controlScene.style.opacity = 0.1;
        }
        let drawerMisson = document.getElementsByClassName("drawer-mission")[0];
        if (drawerMisson) {
          drawerMisson.style.display = "none";
        }
        let missionBoard = document.getElementsByClassName("mission-board")[0];
        if (missionBoard) {
          missionBoard.style.display = "none";
        }
        this.$refs?.videogameplayer?.closeMissionBoard();
      });
      this.plyr.on("loadedmetadata", () => {
        this.duration = video.duration;
        this._makeShowCaseMainScene();
        let progressBarElm = document.querySelector(".plyr__progress");
        if (progressBarElm) {
          let makersEls = progressBarElm.getElementsByClassName("marker");
          while (makersEls.length > 0) {
            makersEls[0].parentNode.removeChild(makersEls[0]);
          }
        }

        if (this.isHintItem) {
          for (const timeScene of this.showcaseMainScene) {
            let marker = document.createElement("div");
            marker.addEventListener("click", () => {
              this.seekVideo(timeScene);
            });
            marker.classList.add("marker");
            marker.style.left = `${(timeScene * 100) / this.duration}%`;
            progressBarElm.appendChild(marker);
          }
        }
      });
      this.plyr.on("enterfullscreen", () => {
        console.log("enterfullscreen");
        updateAdsPosition();
        this.slotPanel = false;
        this.showPrPanel = false;
      });
      this.plyr.on("waiting", () => {
        this.showIconShopping = false;
      });
      this.plyr.on("canplay", () => {
        this.showIconShopping = true;
      });
      this.plyr.elements.container.appendChild(domAdsContainer);
      return video;
    },
    _addEventTimeUpdateAndFullScreen(video) {
      const updateAdsPosition = () => {
        const messages = this.getCurrentMetaWithPos();
        let index = 0;
        for (let oldShop of this.shops) {
          let updateShop = _.find(messages, { id: oldShop.id });
          if (updateShop) {
            const clientW = this.video.clientWidth;
            const clientH = this.video.clientHeight;
            oldShop.x = updateShop.x * clientW;
            oldShop.y = updateShop.y * clientH;
            oldShop.width = updateShop.width * clientW;
            oldShop.height = updateShop.height * clientH;
            oldShop.lineData = this.calLineAnimate(oldShop.textData, oldShop);
            _.remove(messages, { id: oldShop.id });
          } else {
            this.shops.splice(index, 1);
          }
          index += 1;
        }
        for (const message of messages) {
          const infoShop =
            _.find(this.showcaseCr.metadata || [], {
              id: message.id,
            }) || {};
          const clientW = this.video.clientWidth;
          const clientH = this.video.clientHeight;
          let x = message.x * clientW;
          let y = message.y * clientH;
          let width = message.width * clientW;
          let height = message.height * clientH;
          let pos = message.pos;
          const textData = this.calculatePosText({
            x: x,
            y: y,
            width: width,
            height: height,
            pos: pos,
          });
          let timeStart = Math.round(new Date().getTime() / 1000);
          if (this.productMarkShowed.includes(infoShop.id)) {
            timeStart = 0;
          }
          const newShop = {
            x: x,
            y: y,
            width: width,
            height: height,
            pos: pos,
            textData: textData,
            lineData: this.calLineAnimate(textData, { x: x, y: y, pos: pos }),
            ...infoShop,
            timeStart: timeStart,
          };
          this.shops.push(newShop);
        }
      };
      video.addEventListener("timeupdate", () => {
        // console.log("time update", this.video.currentTime);
        this.timePlay = this.video.currentTime;
        updateAdsPosition();
      });
      video.addEventListener("fullscreenchange", () => {
        console.log("fullscreenchange");
        updateAdsPosition();
      });
      return video;
    },
    _parseMetaHls(video) {
      console.log("Abs _parseMetaHls");
      if (Hls.isSupported() && this.showcaseCr.type_video === "hls") {
        let hls = new Hls();
        hls.on(Hls.Events.MEDIA_ATTACHED, () => {
          hls.loadSource(this.showcaseCr.url_video);
        });
        hls.attachMedia(video);
        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play();
        });
        this.hls = hls;
      }
      return video;
    },
    _makeShowCaseMainScene() {
      /*
       * Tìm các phân đoạn showcase chính, thỏa mãn các itv cách nhau > maxRangeSplitScene
       * Sử dụng kỹ thuận two pointer để giảm chi phí loop
       * */
      let mainScenes = [];
      if (this.missionDetails.id) {
        this.showcaseCr.data = this.showcaseCr.data?.filter((x) => {
          return x.pred_boxes.find((o) => o.id === this.missionDetails.id);
        });
      }

      if (this.showcaseCr.data.length === 1) {
        this.showcaseMainScene = this.showcaseCr.data[0].itv[0];
        return;
      }
      this.showcaseMainScene = [];
      let i = 0;
      let j = i + 1;
      while (j <= this.showcaseCr.data.length - 1) {
        if (
          this.showcaseCr.data[j].itv[0] - this.showcaseCr.data[i].itv[1] <
          this.maxRangeSplitScene
        ) {
          j += 1;
        } else {
          mainScenes.push(this.showcaseCr.data[i].itv[0]);
          i = j;
          j = i + 1;
          if (j === this.showcaseCr.data.length) {
            mainScenes.push(this.showcaseCr.data[i].itv[0]);
          }
        }
      }
      this.showcaseMainScene = mainScenes;
    },
    seekVideo(timeSeek) {
      if (this.timePlay > timeSeek) {
        this.plyr.rewind(Math.abs(this.timePlay - timeSeek));
      } else {
        this.plyr.forward(Math.abs(this.timePlay - timeSeek));
      }
    },
    onNextMainScene() {
      for (const scene of this.showcaseMainScene) {
        if (scene > this.timePlay) {
          console.log(`${this.timePlay} | ${scene}`);
          this.seekVideo(scene);
          return;
        }
      }
    },
    onPreMainScene() {
      const revertArr = [...this.showcaseMainScene];
      revertArr.reverse();
      for (const scene of revertArr) {
        if (scene < this.timePlay - 2) {
          this.seekVideo(scene);
          return;
        }
      }
    },
    async handleChangeContent(content) {
      const url = new URL(window.location.href);
      url.searchParams.set("showcase_id", content.showcase_id);
      window.history.replaceState(null, null, url);
      await this.prepareForNewCnt(content);
    },
    async prepareForNewCnt(content) {
      this.ctnShowcase = content;
      if (this.video) {
        this.duration = 0;
        this.timePlay = null;
        this.shops = [];
        this.productMarkShowed = [];
        this.showcaseMainScene = [];
        this.plyr.restart();
        if (this.hls) {
          this.hls.destroy();
        }
        await this.getDetailShowcase(content.showcase_id);
        this.video.src = this.showcaseCr.url_video;
        this._parseMetaHls(this.video);
        this.video = this._addEventTimeUpdateAndFullScreen(this.video);
        this.video.play();
      }
    },
  },
  async mounted() {
    console.log("Start mixin mounted");
    await this._fetchMessages();
    let video = this._innitVideoPlayer();
    video.src = this.showcaseCr.url_video;
    video = this._addEventTimeUpdateAndFullScreen(video);
    video = this._parseMetaHls(video);
    this.video = video;
    this.video.play();
    console.log("End mixin mounted");
  },
};
export { playerShowcase };
